import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import ContentLoading from "components/common/ContentLoading";
import Job from "interfaces/Job";
import * as $ from "jquery";
import * as moment from "moment";
import * as numeral from "numeral";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import "../../js/jquery.responsiveTabs";

interface RouteParams {
    id: number;
}

interface State {
    isLoading: boolean;
    errorMessage?: string;
    data: Job;
}

export default class ViewBqs extends React.Component<
    RouteComponentProps<RouteParams>,
    State
> {
    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);

        this.state = {
            isLoading: true,
            errorMessage: undefined,
            data: {} as any, // Will be assigned to when componentDidMount is called.
        };
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink to="/jobs-bqs">Projects</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Project Details</BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <h3 className="card__title">{this.state.data.name}</h3>
                    <div id="horizontalTab">
                        <Link to={"/jobs/edit/" + this.state.data.id} className="tab--edit">
                            <i className="icon-edit"></i>
                        </Link>
                        <ul>
                            <li>
                                <a href="#job-overview">Project Overview</a>
                            </li>
                            <li>
                                <a href="#related-quotes">Related Quotes</a>
                            </li>
                        </ul>
                        <div id="job-overview">
                            <div className="box style1">
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">ID</span>
                                        <span className="field-item">{this.state.data.id}</span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">CIS Number</span>
                                        <span className="field-item">
                                            {this.state.data.cisNumber}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Bid Date</span>
                                        <span className="field-item">
                                            {this.state.data.bidDate &&
                                                moment(this.state.data.bidDate).format("LL")}
                                        </span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Type</span>
                                        <span className="field-item">
                                            {this.state.data.jobTypeName}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Project Name</span>
                                        <span className="field-item">{this.state.data.name}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Description</span>
                                        <span className="field-item text-box">
                                            {this.state.data.description}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Estimated Cost</span>
                                        <span className="field-item">
                                            {this.state.data.costEstimate &&
                                                numeral(this.state.data.costEstimate).format("$0,0.00")}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Address</span>
                                        <span className="field-item">
                                            {this.state.data.address}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">City</span>
                                        <span className="field-item">{this.state.data.city}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">State</span>
                                        <span className="field-item">{this.state.data.state}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">County</span>
                                        <span className="field-item">{this.state.data.county}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Salesperson</span>
                                        <span className="field-item">
                                            {this.state.data.salesPerson}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="related-quotes">
                            <table
                                className="table simple-datatable"
                                style={{ width: "100%" }}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ width: "20%" }}>Quote ID</th>
                                        <th style={{ width: "15%" }}>Quote Date</th>
                                        <th style={{ width: "50%" }}>Project Name</th>
                                        <th style={{ width: "15%" }}>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.data.quotes.map((item, index) => {
                                        let quoteId = item.id.toString();
                                        if (item.isMaster) {
                                            quoteId += "M";
                                        }
                                        if (item.revisionDate) {
                                            quoteId +=
                                                ", rev " + moment(item.revisionDate).format("l");
                                        }
                                        if (item.isDraft) {
                                            quoteId += " (Draft)";
                                        }

                                        return (
                                            <tr key={item.id}>
                                                <td>{quoteId}</td>
                                                <td>{moment(item.date).format("LL")}</td>
                                                <td>
                                                    <Link to={`/quotes/${item.id}`}>
                                                        {this.state.data.name}
                                                    </Link>
                                                </td>
                                                <td>{numeral(item.price).format("$0,0.00")}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        if (this.state.isLoading) {
            let response = await apifetch(
                "jobs/" + this.props.match.params.id,
                undefined,
                true
            );
            if (response.ok) {
                let data = (await response.json()) as Job;
                this.setState({
                    isLoading: false,
                    data: data,
                });

                document.title = `${data.name} - Project - ${SITE_NAME}`;

                if ($("#horizontalTab").length == 1) {
                    var $tabs = $("#horizontalTab");
                    $tabs.responsiveTabs({
                        rotate: false,
                        startCollapsed: "accordion",
                        collapsible: "accordion",
                    });
                }
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isLoading: false,
                    errorMessage: errorText,
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/Projects/view-BQS.tsx